module.exports = __webpack_public_path__ + "static/media/icon_nightSelected.0e79e2f4.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/icon_nightSelected.svg
// module id = 2419
// module chunks = 7